import React, { useCallback,useEffect, useState, useRef } from "react";
import styled, { withTheme } from "styled-components";
import useOnClickOutside from 'use-onclickoutside'
import { useDebounce } from 'use-lodash-debounce'


import Markdown from './index'

const Textarea = styled.textarea`
  width: 100%;
  resize: none


`

export default withTheme((props) => {
  const { extra = {},save, id } = props;
  const { content = ''} = extra;
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState(content);

  const ref = useRef()
  useOnClickOutside(ref, () => {save({ _id : id, key: 'content', value }); setEdit(false)})

  const debouncedValue = useDebounce(value, 500);

  useEffect(() => {
    if (ref.current) {
      save({ _id : id, key: 'content', value: debouncedValue });
    } else {
      ref.current = true;
    }
  }, [debouncedValue,id]); // including save as linting suggest will break the update. 

  // useEffect(() => {
  //   if( label !== value ) {
  //     setValue(label)
  //   }
  // }, [label]);

  
  // const handleChange = useCallback( e => {
  //   setValue(e.target.value)
  // }, [])

  if( edit ) {
    return <Textarea onChange={(e)=>setValue(e.target.value)} ref={ref} rows='10' >{value}</Textarea>
  }

  return <div onClick={() => setEdit(true)}><Markdown {...props} builder={true} /></div>

});
